export default "__VITE_PUBLIC_ASSET__4de733c0__"